import { Text } from "@postenbring/hedwig-react";
import Translated from "../infrastructure/translation/Translated";

export function InfoPage() {
  return (
    <main>
      <Text variant="h1" as="h1" size="min">
        <Translated textKey={"infopage.header"} />
      </Text>
    </main>
  );
}
